<app-modal [modalSize]="'modal-medium'">
    <div class="modal-header">
      <h3 class="modal-title">Are you sure?</h3>
    </div>
  
    <div class="modal-body">
        <app-loading-spinner *ngIf="isLoading" ></app-loading-spinner>
      
        <div *ngIf="!isLoading">
            <h6 class="modal-body">
                <ng-container *ngIf="data.isManager; else removeText">
                    Do you want to make <strong>{{ data.userName }}</strong> as a manager of group <strong>{{ data.groupName }}</strong>?
                </ng-container>
                <ng-template #removeText>
                    Do you want to remove <strong>{{ data.userName }}</strong> as a manager of group <strong>{{ data.groupName }}</strong>?
                </ng-template>
            </h6>

        </div>
    </div>
  
    <div class="modal-footer">
      <div (click)="save()" class="btn btn-primary">Confirm</div>
      <div (click)="closeModal()" class="btn btn-cancel">Cancel</div>
    </div>
</app-modal>